import { useSerialPortStore } from '@/contexts/serial-port/store';
import { useEffect } from 'react';
import toast from 'react-hot-toast';

export function SerialPortProvider({ children }: { children: React.ReactNode }) {
  const { setPorts, addLog, setLivestockRFIDScanner, setLivestockScales, setLivestockBarcodeScanner } =
    useSerialPortStore();

  async function loadPorts() {
    try {
      const portList = await window.electronAPI.serialPort.listSerialPorts();

      setPorts(portList);
      addLog('info', 'Lista de portas carregada');
    } catch (error) {
      addLog('error', `Erro ao listar portas: ${error}`);
    } finally {
      await checkPortStatus();
    }
  }

  async function checkPortStatus() {
    try {
      const { RFIDScanner, weightScale, barcodeScanner } = await window.electronAPI.serialPort.activePortsList();

      if (RFIDScanner) {
        setLivestockRFIDScanner(RFIDScanner);
        addLog('success', `Conexão com bastão reestabelecida na porta ${RFIDScanner}`);
      }

      if (weightScale) {
        setLivestockScales(weightScale);
        addLog('success', `Conexão com balança reestabelecida na porta ${weightScale}`);
      }

      if (barcodeScanner) {
        setLivestockBarcodeScanner(RFIDScanner);
        addLog('success', `Conexão com leitor de código de barras reestabelecida na porta ${RFIDScanner}`);
      }
    } catch (error) {
      // addLog('error', `Erro ao verificar status das portas: ${error}`);
    }
  }

  useEffect(() => {
    loadPorts();

    window.electronAPI.serialPort.on('updated-serial-ports-list', (_, newPorts) => {
      // TODO: verificar se as portas que estão conectaras aparecem na lista, senão elas devem ser desconectadas
      setPorts(newPorts.data);
      addLog('info', 'Lista de portas atualizada');
    });

    window.electronAPI.serialPort.on('connected-device', (_, data) => {
      toast.success(data.message);
      addLog('success', data.message);

      if (data.type === 'RFIDScanner') {
        setLivestockRFIDScanner(data.port);
      } else if (data.type === 'weightScale') {
        setLivestockScales(data.port);
      } else if (data.type === 'barcodeScanner') {
        setLivestockBarcodeScanner(data.port);
      }
    });

    window.electronAPI.serialPort.on('disconnected-device', (_, data) => {
      toast.success(data.message);
      addLog('warning', data.message);

      if (data.type === 'RFIDScanner') {
        setLivestockRFIDScanner(null);
      } else if (data.type === 'weightScale') {
        setLivestockScales(null);
      } else if (data.type === 'barcodeScanner') {
        setLivestockBarcodeScanner(null);
      }
    });

    window.electronAPI.serialPort.on('received-data', (_, data) => {
      if (data.type === 'RFIDScanner') {
        addLog('success', `Dados recebidos do bastão: ${data.message}`);
      } else if (data.type === 'weightScale') {
        console.log(`Dados recebidos da balança: ${data.message}`);
        // addLog('success', `Dados recebidos da balança: ${data.message}`);
      } else if (data.type === 'barcodeScanner') {
        addLog('success', `Dados recebidos do leitor: ${data.message}`);
      }
    });

    // ----------------------------------------------------------------------

    window.electronAPI.serialPort.on('erro-porta', (_event, mensagem) => {
      console.log('error', `Erro: ${mensagem}`);
      addLog('error', `Erro: ${mensagem}`);
      // setConected(false);
    });

    window.electronAPI.serialPort.on('dispositivo-removido', (_event, data) => {
      console.log('info', data.mensagem);
      addLog('info', data.mensagem);
    });

    // Limpar listeners ao desmontar
    // return () => {
    //   window.electronAPI.serialPort.removeAllListeners('dados-recebidos');
    //   window.electronAPI.serialPort.removeAllListeners('erro-porta');
    //   window.electronAPI.serialPort.removeAllListeners('lista-portas-atualizada');
    //   window.electronAPI.serialPort.removeAllListeners('dispositivo-conected');
    //   window.electronAPI.serialPort.removeAllListeners('dispositivo-removido');

    //   // Fechar porta ao desmontar
    //   window.electronAPI.serialPort.send('fechar-porta');
    // };
  }, []);

  return children;
}
